import React from 'react';
import s from './Leads.module.scss';

const REGION_STYLES = {
  long_trip: { label: 'Long trip' },
  outside: { label: 'Outside region' },
};

const DIRECTION_LABEL = {
  outbound: 'Outbound',
  inbound: 'Inbound',
};

const LeadRegionBadge = ({ lead, className }) => {
  const regionClass = lead?.region_class;
  const style = REGION_STYLES[regionClass];
  if (!style) return null;
  const direction = regionClass === 'long_trip' ? DIRECTION_LABEL[lead.region_direction] : null;
  return (
    <span
      className={`${s.regionBadge} ${regionClass === 'long_trip' ? s.regionBadgeLongTrip : s.regionBadgeOutside}${className ? ` ${className}` : ''}`}
    >
      {style.label}{direction ? ` · ${direction}` : ''}
    </span>
  );
};

export default LeadRegionBadge;
